import { type ApiResult, type BaseParams, type SalesVolume } from '@app/client/common';
import { Request } from '@app/client/common/api';
import { links } from '@app/client/links';

import { apiReturnResults } from '../../../../ApiFactory';

const getCollectionSalesVolume = (params: BaseParams): Promise<ApiResult<SalesVolume>> => {
    return Request.getRequest<SalesVolume>({
        ...params,
        target: links.daas().v2.stats.collection.salesVolume,
        apiSettingsType: 'daasV2',
    });
};

export const callGetCollectionSalesVolume = (params: BaseParams) =>
    apiReturnResults<SalesVolume>(getCollectionSalesVolume, params, true);
